import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import "@/assets/scss/reset.scss"
import 'amfe-flexible'
import './config/vant'

import {trimAll, loading, cutWord, message} from '@/utils/untils'
Vue.config.productionTip = false;

Vue.prototype.trimAll = trimAll
Vue.prototype.$loading = loading
Vue.prototype.cutWord = cutWord
Vue.prototype.$$message = message

declare module 'vue/types/vue' {
  interface Vue {
    trimAll: any,
    $loading: any,
    cutWord: any,
    $$message: any
  }
}


new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
